import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'Admin' },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/layouts/AuthLayout.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: { name: 'Homepage' },
    meta: { auth: true },
    children: [
      {
        path: 'places',
        name: 'Places',
        component: () => import('@/views/places/Places.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'places/create',
        name: 'NewPlace',
        component: () => import('@/views/places/Place.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'places-travel',
        name: 'PlacesTravel',
        component: () => import('@/views/places/PlacesTravel.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'places-travel/create',
        name: 'NewPlaceTravel',
        component: () => import('@/views/places/PlaceTravel.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: '/places/:id',
        name: 'EditPlace',
        component: () => import('@/views/places/Place.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: '/places-travel/:id',
        name: 'EditPlaceTravel',
        component: () => import('@/views/places/PlaceTravel.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'place-types',
        name: 'PlaceTypes',
        component: () => import('@/views/placeTypes/PlaceTypes.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'place-types-order',
        name: 'PlaceTypesOrder',
        component: () => import('@/views/placeTypes/PlaceTypesOrder.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'homepage',
        name: 'Homepage',
        component: () => import('@/views/homepage/Homepage.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'new-place-type',
        name: 'NewPlaceType',
        component: () => import('@/views/placeTypes/PlaceType.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'place-types/:id',
        name: 'EditPlaceType',
        component: () => import('@/views/placeTypes/PlaceType.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'routes',
        name: 'Routes',
        component: () => import('@/views/routes/Routes.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'routes-order',
        name: 'RoutesOrder',
        component: () => import('@/views/routes/RoutesOrder.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'new-route',
        name: 'NewRoute',
        component: () => import('@/views/routes/Route.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'routes/:id',
        name: 'EditRoute',
        component: () => import('@/views/routes/Route.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'routes/:id/new-route-point',
        name: 'NewRoutePoint',
        component: () => import('@/views/routePoints/RoutePoint.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'routes/:id/route-point/:pointId',
        name: 'EditRoutePoint',
        component: () => import('@/views/routePoints/RoutePoint.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'authors',
        name: 'Authors',
        component: () => import('@/views/authors/Authors.vue'),
        meta: { guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'new-author',
        name: 'NewAuthor',
        component: () => import('@/views/authors/Author.vue'),
        meta: { mode: 'create', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
      {
        path: 'authors/:id',
        name: 'EditAuthor',
        component: () => import('@/views/authors/Author.vue'),
        meta: { mode: 'edit', guard: () => store.dispatch('auth/ActionCheckAuth') },
      },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const PAGE_TITLES = {
  Auth: 'Вход',
  Homepage: 'Главная',
  Places: 'Посетить',
  NewPlace: 'Создать место',
  EditPlace: 'Редактировать место',
  PlacesTravel: 'Отдых',
  NewPlaceTravel: 'Создать место',
  EditPlaceTravel: 'Редактировать место',
  PlaceTypes: 'Типы мест',
  PlaceTypesOrder: 'Порядок типов мест',
  NewPlaceType: 'Создать тип места',
  EditPlaceType: 'Редактировать тип места',
  Routes: 'Маршруты',
  RoutesOrder: 'Порядок маршрутов',
  NewRoute: 'Создать маршрут',
  EditRoute: 'Редактировать маршрут',
  NewRoutePoint: 'Создать точку маршрута',
  EditRoutePoint: 'Редактировать точку маршрута',
  Authors: 'Авторы',
  NewAuthor: 'Создать автора',
  EditAuthor: 'Редактировать автора',
  NotFound: 'Страница не найдена',
};

router.afterEach((to) => {
  const pageTitle = PAGE_TITLES[to.name];
  document.title = pageTitle
    ? `${pageTitle} — Орёл Туристический`
    : 'Орёл Туристический';
});

router.beforeEach(async (to, from, next) => {
  const isGuardedRoute =
    Object.prototype.hasOwnProperty.call(to.meta, 'guard') && typeof to.meta.guard === 'function';

  if (!isGuardedRoute) {
    next();
  } else if (await to.meta.guard()) {
    next();
  } else {
    next({ name: 'Auth' });
  }
});

export default router;
